import React from 'react'
import Link from 'next/link'
import { postLink } from '@components/blog/utils/postLinks'
import { boldenKeywords } from '@components/shared/FAQ'

import styles from '@components/blog/styles/TextSearch.module.css'

const boldKeywords = (text, words) => boldenKeywords(text, words, '', '', '<b>', '</b>')

const API_ROUTE = '/api/blog/text_search/'
const MIN_PHRASE_LENGTH = 3
const TIMEOUT = 600

const HINT_ID = 'hint-value'
const TIMEOUT_ID = 'timeout'
const UNMOUNTED_ID = 'unmounted'

const MATCH_CLASS = `${styles['text-hints']} ${styles['matching-content']}`

// TODO: replace React Components (low priority)
function withTextSearch (TargetComponent) {
    return class TextSearch extends React.Component {
        state = {
            value: '',
            hints: {},
            loading: false,
        }

        componentWillUnmount () {
            this[UNMOUNTED_ID] = true
        }

        onChange = ({ target: { value }}) => {
            this.setState({ value }, this.startFetchingHints)
        }

        startFetchingHints = () => {
            clearTimeout(this[TIMEOUT_ID])

            this[TIMEOUT_ID] = setTimeout(() => {
                if (!this[UNMOUNTED_ID] && this.shouldFetchHints()) {
                    this.setState({ loading: true }, this.fetchHints)
                }
            }, TIMEOUT)
        }

        fetchHints = () => {
            this[HINT_ID] = this.state.value
            const apiRoute = this.apiRoute()

            fetch(apiRoute)
                .then(res => res.json())
                .then(hints => {
                    if (!this[UNMOUNTED_ID]) {
                        this.setState({ hints, loading: false })
                    }
                })
        }

        apiRoute = () => {
            const { value } = this.state
            return API_ROUTE + value
        }

        shouldFetchHints = () => {
            const { value, loading } = this.state
            return !loading
                && value
                && value.length >= MIN_PHRASE_LENGTH
                && value !== this[HINT_ID]
        }

        render () {
            return (
                <>
                    { this.renderInput() }
                    { this.renderHints() }
                </>
            )
        }

        renderInput = () => {
            const { loading, value } = this.state
            return (
                <TargetComponent
                    {...this.props}
                    loading={ loading }
                    value={ value }
                    onChange={ this.onChange }
                />
            )
        }

        renderHints = () => {
            return !this.shouldRenderHints()
                ? null
                : (
                    <>
                        { this.renderHintsMatchingTitle() }
                        { this.renderHintsMatchingContent() }
                    </>
                )

        }

        shouldRenderHints = () => {
            const { value, hints } = this.state
            return value
                && value.length >= MIN_PHRASE_LENGTH
                && hints.length > 0
        }

        renderHintsMatchingTitle = () => {
            const { inTitle, resultsInTitle } = this.state.hints || {}
            if (!inTitle) return null

            return (
                <div className={MATCH_CLASS}>
                    <br/><br/>
                    { this.renderHintsList(resultsInTitle, this.renderHintsMatchingTitleItem) }
                </div>
            )
        }

        renderHintsMatchingContent = () => {
            const { inTitle, inContent, resultsInContent } = this.state.hints || {}
            if (!inContent) return null

            return (
                <div className={MATCH_CLASS}>
                    { Boolean(inTitle) && <hr/> }
                    <h3>W treści:</h3>
                    { this.renderHintsList(resultsInContent, this.renderHintsMatchingContentItem) }
                </div>
            )
        }

        renderHintsList = (hintArray, hintRenderFunction) => {
            return hintArray
                .map(hint => {
                    const { docType, slug, ...rest } = hint
                    const url = postLink({ docType, slug })
                    return (
                        <Link href={url} key={slug}>
                            <a>
                                { hintRenderFunction(rest) }
                            </a>
                        </Link>
                    )
                })
        }

        renderHintsMatchingTitleItem = ({ title, subtitle }) => {
            const keywords = [this.state.value]
            return (
                <>
                    <h4 dangerouslySetInnerHTML={{
                        __html: boldKeywords(title, keywords) }} />
                </>
            )
        }

        renderHintsMatchingContentItem = ({ title, subtitle, content }) => {
            const keywords = [this.state.value]
            return (
                <>
                    <h4>{ title }</h4>
                    <p dangerouslySetInnerHTML={{
                        __html: boldKeywords(content, keywords)
                    }} />
                </>
            )
        }
    }
}

export default withTextSearch